module.exports = new __parcel__URL__("magic-search.dbdce574.svg").toString();